/**
 * Specializations offered in the onboarding dropdown. Sent to the backend as
 * the documented `specialization` string.
 */
export const SPECIALIZATIONS = [
  "Dentist",
  "General Physician",
  "Pediatrician",
  "Ayurveda",
  "Orthopedic Surgeon",
  "Dental Surgeon",
  "Dermatologist",
  "Cosmetic/Aesthetic Dentist",
  "General Surgeon",
  "Cardiologist",
  "Neurologist",
  "Gynecologist",
  "ENT Specialist",
  "Ophthalmologist",
  "Psychiatrist",
  "Psychologist",
  "Pulmonologist",
  "Gastroenterologist",
  "Endocrinologist",
  "Nephrologist",
  "Oncologist",
  "Urologist",
  "Rheumatologist",
  "Physiotherapist",
  "Homeopath",
  "Nutritionist/Dietitian",
] as const;

export const GENDERS = ["Female", "Male", "Other", "Prefer not to say"] as const;

export const LANGUAGE_OPTIONS = [
  "English",
  "Hindi",
  "Bengali",
  "Marathi",
  "Telugu",
  "Tamil",
  "Gujarati",
  "Kannada",
  "Malayalam",
  "Punjabi",
  "Urdu",
  "Odia",
  "Spanish",
  "French",
  "Arabic",
] as const;

/** DOCX: registration years run from 1926 to the current year, computed live. */
export const REGISTRATION_START_YEAR = 1926;

export function registrationYears(now: Date = new Date()): number[] {
  const latest = now.getFullYear();
  const years: number[] = [];
  for (let year = latest; year >= REGISTRATION_START_YEAR; year -= 1) years.push(year);
  return years;
}
